import debug from "debug";
import ApiManagement from "./api-management";

const log = debug("ApiManagement:Liveshows");

class BoostBanner extends ApiManagement {
	getBanners({ customerId, locationId }) {
		let url = `//${this.settings.url}/Aggregation/GetBannersWithSettings?externalBannerLocationId=${locationId}`;
		if (customerId !== undefined) {
			url = `//${this.settings.url}/Aggregation/GetBannersWithSettings?customerId=${customerId}&externalBannerLocationId=${locationId}`;
		}
		// const url = '//dev-minetilbud-contentapi.azurewebsites.net/v1/gdpr/categories';
		return this.get(url);
	}
}

export default BoostBanner;
